import supportModule from '../../support.module';

export default supportModule.factory(
    'supportSystemService',
    ($q, accountProvider, configUiService) => {
        return {
            getSupportContact
        };

        function getSupportContact() {
            var defer = $q.defer();
            getSupportContactStatus().then(function(enable) {
                if (enable) {
                    configUiService
                        .getSupportContact()
                        .then(defer.resolve, defer.reject);
                } else {
                    defer.resolve([]);
                }
            }, defer.reject);
            return defer.promise;
        }

        function getSupportContactStatus() {
            var defer = $q.defer();
            accountProvider.getAccountPlan().then(function(response) {
                defer.resolve(response.metadata.supportTypePhone == 'true');
            }, defer.reject);
            return defer.promise;
        }
    }
);



// WEBPACK FOOTER //
// ./modules/support/services/supportSystem/supportSystem.service.js